import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Observable } from "rxjs";
import { Group } from "../_types/group";

@Injectable({
    providedIn: 'root',
})

export class GroupsService extends Service<Group> {
    public override type = 'groups';
    public override url = 'auth/groups';

}
